import UnitsModule from '../modules/UnitModule/store/units.module';
import {loadProject, updateProject} from '@/modules/ProjectModule/api/project.api';
import * as phase from './parts/phase.module-part';
import * as status from './parts/status.module-part';
import * as types from './parts/type.module-part';
import * as disposition from './parts/disposition.module-part';
import * as orientation from './parts/orientation.module-part';
import FloorPlanModule from './floor-plan.module';
import SubscriptionModule from './subscription.module';
import BuildingModule from './building.module';
import AccessoryModule from './accessory.module';
import CustomerModule from '../modules/CustomerModule/store/customer.module';
import ExtensionModule from '../modules/ExtensionModule/store/extension.module';

function initialState() {
    return {
        data:         {
            title:       null,
            description: null,
        },
        projectId:    null,
        phases:       [],
        statuses:     [],
        types:        [],
        dispositions: [],
        orientations: [],
        images:       [],
        files:        [],
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters:    {
        projectId:   (state) => state.projectId,
        siteId:      (state) => state.data.site ? state.data.site.id : null,
        data:        (state) => state.data,
        title:       (state, getters) => getters.data.title,
        description: (state, getters) => getters.data.description,
        category:    (state, getters) => getters.data.category,
        isBroker:    (state, getters) => getters.category === 'BROKER',

        ...phase.getters,
        ...status.getters,
        ...types.getters,
        ...disposition.getters,
        ...orientation.getters,
    },
    actions:    {
        setProjectId: ({commit, dispatch}, projectId) => commit('SET_PROJECT_ID', projectId),
        async init({dispatch}, projectId) {
            dispatch('reset');
            dispatch('setProjectId', projectId);
            await dispatch('loadProject');
            await Promise.all([
                dispatch('loadPhases'),
                dispatch('loadStatuses'),
                dispatch('loadTypes'),
                dispatch('loadDispositions'),
                dispatch('loadOrientations'),
                dispatch('projects/project/floorPlan/loadFloorPlans', {}, {root: true}),
                dispatch('projects/project/subscription/loadSubscription', {}, {root: true}),
                dispatch('projects/project/building/loadBuildings', {}, {root: true}),
                dispatch('projects/project/accessory/loadAccessoryTypes', {}, {root: true}),
                dispatch('projects/project/customer/init', {}, {root: true}),
                dispatch('media/init', {}, {root: true}),
            ]);
        },

        async loadProject({commit, getters, dispatch}) {
            const project = await loadProject(getters.projectId);
            const {media} = project;
            dispatch('media/setMediaId', media.id, {root: true})
            commit('SET_PROJECT', project)
        },
        async updateProject({commit, getters, dispatch}, data) {
            const id = getters.projectId;
            return updateProject({...data, id})
                .then((data) => {
                    commit('SET_PROJECT', data);
                    dispatch('projects/loadProjects', {}, {root: true});
                });
        },

        ...phase.actions,
        ...status.actions,
        ...types.actions,
        ...disposition.actions,
        ...orientation.actions,

        reset: ({commit, dispatch}) => {
            commit('RESET');
            dispatch('projects/project/floorPlan/reset', {}, {root: true});
            dispatch('projects/project/building/reset', {}, {root: true});
            dispatch('projects/project/accessory/reset', {}, {root: true});
            dispatch('projects/project/customer/reset', {}, {root: true});
        },
    },
    mutations:  {
        SET_PROJECT_ID: (state, projectId) => state.projectId = projectId,
        SET_PROJECT:    (state, data) => state.data = data,

        ...phase.mutations,
        ...status.mutations,
        ...types.mutations,
        ...disposition.mutations,
        ...orientation.mutations,

        RESET: (state) => {
            const s = initialState();
            Object.keys(s).forEach(key => state[key] = s[key]);
        }
    },
    modules:    {
        units:        UnitsModule,
        floorPlan:    FloorPlanModule,
        building:     BuildingModule,
        accessory:    AccessoryModule,
        customer:     CustomerModule,
        extension:    ExtensionModule,
        subscription: SubscriptionModule
    }
}
